<template>
  <div id="page-layout">
    <form class="edit-form login-form"
          novalidate
          @submit.prevent="handleSubmit"
          name="reset-password">

      <h1 class="big-title">{{ $t("titles.reset_password") }}</h1>

      <c-input name="passwordNew" v-model.trim="passwordNew" ref="passwordNew" id="passwordNew"
               label="user.password_new" type="password" v-validate="'required|password'"/>

      <c-input name="passwordNewConfirm" v-model.trim="passwordNewConfirm" ref="passwordNewConfirm"
               id="passwordNewConfirm" label="user.password_new_confirm" type="password"
               v-validate="'required|password'"
               data-vv-as="passwordNew"/>

      <div class="actions login-actions">
        <input
          class="solid-button"
          style="flex-grow: 1"
          type="submit"
          v-bind:value="$t('actions.reset_password')">
      </div>
    </form>
  </div>
</template>
<script>
  import userService from "../services/userService.js";
  import Utils from "../services/utils.js"

  export default {
    data() {
      return {
        passwordNew: "",
        passwordNewConfirm: "",
        token: ""
      };
    },
    methods: {
      handleSubmit() {
        this.$validator.validate().then(valid => {
          if (!Utils.isBlank(this.passwordNew) && this.passwordNew !== this.passwordNewConfirm) {
            this.errors.add({
              field: 'passwordNew',
              msg: this.$t('messages.pwd_confirm')
            });
            this.errors.add({
              field: 'passwordNewConfirm',
              msg: this.$t('messages.pwd_confirm')
            });
            valid = false
          }
          if (valid) {
            userService.resetPassword(this.token, this.passwordNew, this.passwordNewConfirm)
              .then(() => {
                this.$store.dispatch('alert/success', this.$t("alerts.reset_password_success"));
                this.$store.dispatch('user/login').then(() => {
                  this.$router.push({path: '/'})
                });
              })
              .catch(() => {
                this.$store.dispatch('alert/error', {message: this.$t("alerts.reset_password_error")});
              });
          }
        });
      }
    },
    beforeCreate() {
      localStorage.setItem('locale', this.$route.query.locale);
      this.$i18n.locale = this.$route.query.locale;
    },
    mounted() {
      this.token = this.$route.params.token;
    }
  };
</script>
<style lang="scss" scoped>
  @import "../style/form.scss";

  #page-layout {
    display: grid;
    grid-template-columns: 30% [content] auto 30%;
    padding-top: 8%;
    padding-bottom: 4%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/resetPassword.vue